import { render, staticRenderFns } from "./TuitionRegisterAdmin.vue?vue&type=template&id=28e8baf8&"
import script from "./TuitionRegisterAdmin.vue?vue&type=script&lang=js&"
export * from "./TuitionRegisterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TuitionRegisterAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports